




































import { Vue, Component } from 'vue-property-decorator';
import * as Util from './util';
import T from '../lang';
import JSZip, { JSZipObject } from 'jszip';
import store from './GraderStore';

@Component
export default class ZipViewer extends Vue {
  zip: JSZip | null = null;
  active: string | null = null;
  T = T;

  get theme(): string {
    return store.getters['theme'];
  }

  get contents(): string {
    return store.getters.zipContent;
  }

  select(item: JSZipObject): void {
    item
      .async('string')
      .then((value: string) => {
        store.dispatch('zipContent', value);
      })
      .catch(Util.asyncError);
    this.active = item.name;
  }
}
